<template>
    <div>
        <el-form ref="form" :model="formItem" label-width="120px" class="pr40">
            <el-form-item label="角色：" prop="optional_role">
                <ESelect v-model="formItem.optional_role" multiple filterable :disabled="isView" class="full-w" :loading="roleLoading" placeholder="请选择角色">
                    <el-option
                        v-for="item in roleList"
                        :key="item.role_id"
                        :label="item.role_name"
                        :value="item.role_id">
                        {{item.role_name}}
                    </el-option>
                </ESelect>
            </el-form-item>
        </el-form>

        <div class="dialog-footer pt20 tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div v-else class="dialog-footer pt20 tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </div>
</template>

<script>
    import API from '@/api/role';
    export default {
        name: "ConfigOptionRoleModal",
        props:{
            isView:{
                type: Boolean,
                default:false,
            },
            page:{
                type: Object,
                required: true
            },
            cbs:{
                type:Object,
            },
            roleList:Array,
        },
        data() {
            return {
                formItem: {
                    optional_role: [],
                },
                // roleList:[],
                roleLoading:false,
            }
        },
        computed: {
        },
        mounted(){
            // this.getRoleList();

            let optionalRole = this.page.optional_role_val;
            if(optionalRole&&optionalRole.length>0){
                this.formItem.optional_role = optionalRole.map(item=>item);
            }
        },
        methods: {
            handleClose() {
                this.$emit('close');
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.cbs.onSubmit(this.formItem);
                        this.handleClose();
                    } else {
                        return false;
                    }
                });
            },
            getRoleList(){
                console.log('getRoleList');
                this.roleLoading = true;
                API.getAllRoleList().then(res => {
                    let resData = res.data||[];
                    console.log('getAllRoleList',res,resData);
                    this.roleList =(resData||[]).map(item=>{
                        return {
                            role_id:item.id,
                            role_name:item.role_name,
                        }
                    });
                    this.roleLoading = false;

                    let optionalRole = this.page.optional_role_val;
                    if(optionalRole&&optionalRole.length>0){
                        this.formItem.optional_role = optionalRole.map(item=>item);
                    }

                }, (err) => {
                    console.log('getAllRoleList error', err);
                    this.roleList = [];
                    this.roleLoading = false;
                });
            },
        },

    }
</script>

<style scoped>

</style>
